import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";
import { EMERGING_ENTERPRISE_FORM } from "@util/constant";

/**
 * Component to render EE apply now page
 */
const EEApplyNowPage = (): React.ReactElement => {
  return (
    <div
      data-testid="ee-apply-now-page-component"
      className="mb-5 font-public-sans"
    >
      <BlockTitle
        text="Download Application Form"
        rootClassName="pt-3 pb-2 text-4xl text-xl lg:text-8xl font-medium"
      />

      <div className="mb-6 flex flex-col items-center justify-between border border-gray-850 px-6 py-10 lg:flex-row">
        <div>
          <p className="mb-0 text-xl font-semibold">
            Emerging Enterprise Award Application Form
          </p>

          <p className="pb-6 lg:pb-0">
            Download this form and send it to&nbsp;
            <a
              href="mailto:EE2025@rsmsingapore.sg"
              className="text-blue-175 hover:underline"
            >
              EE2025@rsmsingapore.sg
            </a>
            &nbsp;by 30 June 2025
          </p>
        </div>

        <Link
          to={EMERGING_ENTERPRISE_FORM}
          target="_blank"
          className="rounded-full bg-gray-850 px-8 py-3 font-poppins text-base font-medium text-white hover:bg-gray-675"
        >
          DOWNLOAD
        </Link>
      </div>

      <p className="w-full text-center text-gray-850">
        For more information, checkout our&nbsp;
        <a
          href={RouteFactory.eeFaqPage}
          className="font-bold text-blue-175 hover:underline"
        >
          FAQs
        </a>
      </p>
    </div>
  );
};

export default EEApplyNowPage;
